import _useDeleteAnonymousAttachmentMutation from "./__generated__/useDeleteAnonymousAttachmentMutation.graphql";
import { ConnectionHandler, graphql, newId, useMutation } from "@workflows/runtime-web";
import { useViewerTenant } from "@workflows/ui";
import { useDeleteAnonymousAttachmentMutation, useDeleteAnonymousAttachmentMutation$data } from "./__generated__/useDeleteAnonymousAttachmentMutation.graphql";
interface useDeleteAttachmentProps {
  onError: (error: Error) => void;
  onCompleted: (data: useDeleteAnonymousAttachmentMutation$data) => void;
  input: {
    attachmentId: string;
    code: string;
    refId: string;
  };
}
interface useDeleteAttachmentValue {
  deleteAnonymousAttachment: (props: useDeleteAttachmentProps) => void;
  isPending: boolean;
}
export const useDeleteAnonymousAttachment = (): useDeleteAttachmentValue => {
  const {
    tenantId
  } = useViewerTenant(true);
  const [mutation, isPending] = useMutation<useDeleteAnonymousAttachmentMutation>(deleteAnonymousAttachmentMutation);
  const deleteAnonymousAttachment = (props: useDeleteAttachmentProps) => {
    const {
      onError,
      onCompleted,
      input: {
        attachmentId,
        code,
        refId
      }
    } = props;
    const connectionID = ConnectionHandler.getConnectionID(refId, "useAttachmentsFragment_attachments");
    mutation({
      variables: {
        input: {
          tenantId,
          clientMutationId: newId(),
          attachmentId,
          code
        },
        connections: [connectionID]
      },
      onError,
      onCompleted
    });
  };
  return {
    deleteAnonymousAttachment,
    isPending
  };
};
const deleteAnonymousAttachmentMutation = (_useDeleteAnonymousAttachmentMutation.hash && _useDeleteAnonymousAttachmentMutation.hash !== "da6df97dd85799100fd17f22ed682c35" && console.error("The definition of 'useDeleteAnonymousAttachmentMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useDeleteAnonymousAttachmentMutation);